import * as React from 'react';
import Typeform from './typeform';
import SurveySparrow from './surveySparrow';
import { PATHS } from '@ids/router/routes';
import useIDSPush from '@ids/hooks/useIDSPush';
import { useOverwhelmedOverlayDispatch } from '@ids/context/OverwhelmedOverlay';
import { TRACKING_IDS_PAGE_LABELS, useFeatureToggle } from '@ids/appshell';
import { QuestionnairePageProvider } from '@ids/context/QuestionnairePage';
import usePageViewTracking from '@ids/hooks/usePageViewTracking';

const Questionnaire = React.memo(() => {
    const { p100StudioSurveySparrow } = useFeatureToggle();

    return <div data-testid="ids-questionnaire-page">{p100StudioSurveySparrow ? <SurveySparrow /> : <Typeform />}</div>;
});

Questionnaire.displayName = 'Questionnaire';

const QuestionnairePage = () => {
    usePageViewTracking(TRACKING_IDS_PAGE_LABELS.QUESTIONNAIRE);

    const { p100IdsOverwhelmedOverlay } = useFeatureToggle();
    const { showOverwhelmedOverlay } = useOverwhelmedOverlayDispatch();
    const push = useIDSPush();

    if (p100IdsOverwhelmedOverlay) {
        push(PATHS.LANDING_PAGE);
        showOverwhelmedOverlay();
        return null;
    }

    return (
        <QuestionnairePageProvider>
            <Questionnaire />
        </QuestionnairePageProvider>
    );
};

export default QuestionnairePage;
